<template>
    <Teleport to="body">
        <div class="collapsible-sidebar-container">
            <!-- Overlay for click-outside -->
            <Transition name="sidebar-fade">
                <div v-if="isOpen" class="collapsible-sidebar-overlay" @click="closeSidebar"></div>
            </Transition>
            <Transition name="sidebar-slide">
                <aside v-if="isOpen" class="collapsible-sidebar" @click.stop>
                    <div class="collapsible-sidebar__header">
                        <button class="close-btn" @click="closeSidebar" aria-label="Close sidebar">
                            <span class="icon"><i class="fas fa-times"></i></span>
                        </button>
                    </div>
                    <div class="sidebar-content">
                        <slot name="content"></slot>
                    </div>
                    <div class="sidebar-footer">
                        <slot name="footer"></slot>
                    </div>
                </aside>
            </Transition>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
    import { ref, onUnmounted, watch } from "vue";
    import { useModalStack } from "../useModalStack";

    const isOpen = ref(false);

    function openSidebar() {
        isOpen.value = true;
    }
    function closeSidebar() {
        isOpen.value = false;
    }

    defineExpose({ openSidebar, closeSidebar });

    const { pushOpen, popClose } = useModalStack(closeSidebar);

    watch(isOpen, val => {
        if (val) {
            pushOpen();
        } else {
            popClose();
        }
    });

    onUnmounted(() => {
        if (isOpen.value) {
            popClose();
        }
    });
</script>

<style scoped></style>
